export enum PriceTier {
    RETAIL = 1,
    NEWDST = 2,
    WHLD05 = 3,
    WHLD08 = 4,
    WHLD13 = 5,
    WHLD18 = 6,
    WHLSAL = 7,
    RTLD5 = 9,
    RTLD10 = 10,
    RTLD15 = 11,
    WHLD00 = 12,
    NEWFBO = 14
}

export enum PriceTierMemberType {
    FPC = 'FPC',
    FBO = 'FBO',
    RETAIL = 'RETAIL',
    WHLSAL = 'WHLSAL',
    NEWFBO = 'NEWFBO'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/price-tier.enum.ts